// extracted by mini-css-extract-plugin
export default {"container":"DeterminingPositionModal_container__+-MMN","header":"DeterminingPositionModal_header__5B3Z3"};